module.exports = __webpack_public_path__ + "img/ug541.713c1a55.png";